export default ({ get, checkStatus, toJSON }) => ({
  getContentTags: () =>
    get("universe/v1/content_tags").then(checkStatus).then(toJSON),
  getContentTag: (id) =>
    get(`universe/v1/content_tags/${id}`).then(checkStatus).then(toJSON),
  getContentTagVideos: (id) =>
    get(`universe/v1/content_tags/${id}/videos`).then(checkStatus).then(toJSON),
  getContentTagPrintables: (id) =>
    get(`universe/v1/content_tags/${id}/printables`)
      .then(checkStatus)
      .then(toJSON),
  getContentTagBlogPosts: (id) =>
    get(`universe/v1/content_tags/${id}/blog_posts`)
      .then(checkStatus)
      .then(toJSON),
  getFeaturedContent: (id) =>
    get(`universe/v1/content_tags/${id}/featured_content`)
      .then(checkStatus)
      .then(toJSON),
});
